import { type LatLng } from '~/_shared/types/latLng';
import { type PolygonPath } from '~/_shared/types/polygon/polygon.types';
import { areLatLngEqual } from '~/_shared/utils/latLng/latLng.helpers';
import {
  type BoundaryMultiPolygon, type ZoomLevel,
} from '~/store/boundaryItems/boundaryItems.state';

export const toClosedChain = (path: PolygonPath): readonly LatLng[] => {
  const first = path[0];
  const last = path[path.length - 1];

  if (!first || !last) {
    return [];
  }

  const isAlreadyClosed = areLatLngEqual(last, first);
  return isAlreadyClosed ? path : [...path, first];
};

// Boundary geometry is kept at multiple zoom levels (more detail at higher zoom).
// Snapping should use the most detailed version available.
export const getMostDetailedBoundaryPolygons = (paths: Map<ZoomLevel, BoundaryMultiPolygon>): BoundaryMultiPolygon => {
  const highestZoomLevel = Math.max(...paths.keys());
  return paths.get(highestZoomLevel) ?? [];
};
